import { render, staticRenderFns } from "./FaqCategory.vue?vue&type=template&id=35ce03ac&scoped=true&"
import script from "./FaqCategory.vue?vue&type=script&lang=js&"
export * from "./FaqCategory.vue?vue&type=script&lang=js&"
import style0 from "./FaqCategory.vue?vue&type=style&index=0&id=35ce03ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ce03ac",
  null
  
)

export default component.exports